module.exports = "<!-- {{showLoader}} -->\r\n<router-outlet></router-outlet>\r\n\r\n<ng-container *ngIf=\"ui.getLoaderState()\">\r\n    <div\r\n        class=\"an-loader-container\"\r\n        style=\"display:flex;z-index:2000;\"\r\n    >\r\n        <img\r\n            src=\"../assets/loader.gif\"\r\n            alt=\"\"\r\n        >\r\n    </div>\r\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// G:/UTL/BMI/Admin/Admin-ANG/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main